const ADMIN_EMAILS = [
  'cheekybrew@gmail.com'
];

const ADMIN_USERNAMES = [
  'Ch33ks'
];

export const isAdmin = (user) => {
  if (!user) return false;
  
  // Check by email
  if (user.email && ADMIN_EMAILS.includes(user.email.toLowerCase())) {
    return true;
  }
  
  // Check by username
  if (user.displayName && ADMIN_USERNAMES.includes(user.displayName)) {
    return true;
  }
  
  // Check by username field
  if (user.username && ADMIN_USERNAMES.includes(user.username)) {
    return true;
  }
  
  return false;
};

export const requireAdmin = (user) => {
  if (!isAdmin(user)) {
    throw new Error('Admin access required');
  }
  return true;
}; 